import { AirlineIcon } from "@b2bportal/core-ui";

export type RemoteAirlineIconSize = "small" | "medium" | "large";

export interface IRemoteAirlineIconProps {
  // An airline code must consist of two uppercase letters or digits
  airlineCode: string;
  size?: RemoteAirlineIconSize;
  className?: string;
  altText?: string;
}

/**
 * @deprecated use `import { AirlineIcon } from '@b2bportal/core-ui';` instead.
 */
export const RemoteAirlineIcon = (props: IRemoteAirlineIconProps) => {
  const {
    size = "large",
    className,
    airlineCode = "airline_placeholder_icon",
    altText,
  } = props;

  return (
    <AirlineIcon
      airlineCode={airlineCode}
      altText={altText}
      className={className}
      size={size}
    />
  );
};
